export default __webpack_public_path__ + "static/media/RectangularArmImg.2eeffe79.png";